import {RestResource} from "@/api/rest/index";

export default class AthubRestResource extends RestResource {
    constructor({server, resource}) {
        super({server, resource});
    }

    handlePromise(promise) {
        return new Promise(((resolve, reject) => {
            promise.then(response => {
                if (response.status === 200) {
                    if (response.data.success || response.data.code === 200 ||
                        response.data.code === '200' || response.data.code === 'OK') {
                        resolve(response.data.data  === undefined ? response.data.result : response.data.data);
                    } else {
                        reject(response.data.message);
                    }
                } else {
                    let message = response.statusText;
                    if (response.data != null) {
                        if (response.data.message !== undefined) {
                            message = response.data.message;
                        } else if (response.data.msg !== undefined) {
                            message = response.data.msg;
                        } else if (response.data.responseMessage !== undefined) {
                            message = response.data.responseMessage;
                        }
                    }
                    reject(message);
                }
            }, error => {
                reject(error);
            });
        }));
    }

    getAll (athubConfig) {
        return this.handlePromise(super.getAll(athubConfig));
    }

    add (model, athubConfig) {
        return this.handlePromise(super.add(model, athubConfig));
    }

    batchAdd (models, athubConfig) {
        return this.handlePromise(super.batchAdd(models, athubConfig));
    }

    get (id, athubConfig) {
        return this.handlePromise(super.get(id, athubConfig));
    }

    update (id, model, athubConfig) {
        return this.handlePromise(super.update(id, model, athubConfig));
    }

    delete (id, athubConfig) {
        return this.handlePromise(super.delete(id, athubConfig));
    }

    list (search, athubConfig) {
        return this.handlePromise(super.list(search, athubConfig));
    }

    page (pageSearch, athubConfig) {
        return this.handlePromise(super.page(pageSearch, athubConfig));
    }

    count (search, athubConfig) {
        return this.handlePromise(super.count(search, athubConfig));
    }
}
